import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { SNItem, SNItemAccess } from 'src/app/models/snitem';
import { SNUser } from 'src/app/models/snuser';
import { TypeManagerService } from 'src/app/services/type-manager.service';

@ManageType('ItemAccessDialogComponent')
@Component({
  selector: 'app-item-access-dialog',
  templateUrl: './item-access-dialog.component.html',
  styleUrls: ['./item-access-dialog.component.scss']
})
export class ItemAccessDialogComponent implements OnInit {

  public item: SNItem;
  public newAccess: SNItemAccess;

  constructor(private typeManager: TypeManagerService, private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any) {
      if (data && data.item) {
        this.item = data.item;
      }
      this.newAccess = new SNItemAccess(0, '', '', true, false, false, false, 0);
    }

  ngOnInit(): void {
  }
}
